import { render } from "./PatientMedicationHistory.vue?vue&type=template&id=01348c5e&scoped=true"
import script from "./PatientMedicationHistory.vue?vue&type=script&lang=js"
export * from "./PatientMedicationHistory.vue?vue&type=script&lang=js"

import "./PatientMedicationHistory.vue?vue&type=style&index=0&id=01348c5e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01348c5e"]])

export default __exports__